<div class="modal-header" *ngIf="isModal">
  <h4 class="modal-title">{{ 'COMMON.PRINT_PREVIEW' | translate }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div id="modal-print-content" [class]="'dream-travel-content tenant-' + tenant?.consolidator">

    <!-- Cover Page -->
    <div class="travel-cover-page">
      <img class="cover-background-image" [src]="getCoverImage()"
        alt="Immagine di copertina del viaggio" (error)="handleImgError($event)">
      <div class="cover-gradient-overlay"></div>
      <div class="cover-content-wrapper">
        <div class="agency-branding">
          <img *ngIf="logoAdv" [src]="logoAdv" alt="Logo ADV" class="agency-logo">
          <img *ngIf="logoTourOperator" [src]="getAbsoluteTourOperatorLogo()" alt="Logo Tour Operator"
            class="tour-operator-logo">
        </div>

        <div class="travel-title-section">
          <h1 class="dream-title">{{ iter?.name }}</h1>
          <div class="title-decorative-line"></div>
          <!-- <p class="travel-subtitle">{{ 'COMMON.PRINT_DREAM' | translate }}</p> -->
          <div class="travel-subtitle">
            {{ 'COMMON.AGENZIA' | translate }}: {{ iter?.agency.name }}<br>
            {{ iter?.agency.telephone }}<br>
            {{ iter?.agency.email }}
            <ng-container *ngIf="tenant?.printSettings?.referenceAgencyInPrint"><br>{{ 'COMMON.REFERENT' | translate }}: {{ iter?.agency.reference
              }}</ng-container>
          </div>
        </div>

        <div class="cover-footer">
          <div class="travel-date">
            <i class="fas fa-calendar-alt"></i>
            <!-- <span>{{ 'COMMON.CREATE' | translate }} {{ lastUpdate | date:'dd MMMM yyyy' }}</span> -->
            <span>{{ 'COMMON.REFERENCE' | translate }} {{ iter?.riferimento }}</span>
          </div>
          <div class="travel-promise">
            <span class="promise-text">{{ 'COMMON.EMOTION' | translate }}<br>{{ 'COMMON.FROM' | translate }} {{
              iter?.date_start | localizedDate:'dd MMMM yyyy' }} {{ 'COMMON.TO' | translate }} {{ iter?.date_end | localizedDate:'dd MMMM
              yyyy' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Piano Voli - Prima di tutte le tappe -->
    <ng-container *ngIf="iter.passengers">
      <div class="passenger-section" *ngIf="iter?.passengers.length > 0">
        <div class="service-header">
          <div class="service-icon-wrapper passenger-icon">
            <app-print-icon icon="user-friends" [customPath]="getIconPath('user-friends')"></app-print-icon>
          </div>
          <h2 class="service-title">{{ 'COMMON.PASSENGERS' | translate }}</h2>
        </div>
        <div class="passenger-list">
          <div class="passenger-item" *ngFor="let passenger of iter?.passengers">
            <span class="passenger-name">{{ passenger.title }} {{ passenger.name }} {{ passenger.surname }}
              <ng-container *ngIf="passenger.type === 'CHD' || passenger.type === 'INF'">{{ passenger.birthdate
                }}</ng-container></span>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="piano-voli-section" *ngIf="getAllFlights().length > 0">
      <div class="service-header">
                  <div class="service-icon-wrapper flight-icon">
                    <app-print-icon icon="plane" [customPath]="getIconPath('plane')"></app-print-icon>
                  </div>
        <h2 class="service-title">{{ 'COMMON.PLANE_FLIGHT' | translate }}</h2>
      </div>

      <!-- Usa lo stesso design delle flight cards esistenti -->
      <div class="service-list">
        <div class="service-item flight-details-card" *ngFor="let flight of getAllFlights()">
          <ng-container *ngFor="let segment of flight.segments; let segIndex = index; let isLast = last">
            <div class="flight-segment">
              <div class="flight-layover-alert" *ngIf="segIndex > 0">
                <i class="fas fa-exclamation-triangle"></i>
                {{ getLayoverAlertText(flight.segments, segIndex) }}
              </div>

              <div class="flight-route">
                <div class="airport-info">
                  <div class="airport-code">{{ segment.departure?.iata }}</div>
                  <div class="airport-name">{{ segment.departure?.airportName }}</div>
                  <div class="flight-time">{{ formatDateTime(segment.departure.date,
                    segment.departure.hour) }}</div>
                </div>

                <div class="flight-path">
                  <div class="flight-line"></div>
                  <div class="flight-plane-icon">
                    <i class="fas fa-plane"></i>
                  </div>
                  <div class="flight-duration">{{ getSegmentDuration(segment) }}</div>
                </div>

                <div class="airport-info">
                  <div class="airport-code">{{ segment.arrival?.iata }}</div>
                  <div class="airport-name">{{ segment.arrival?.airportName }}</div>
                  <div class="flight-time">{{ formatDateTime(segment.arrival.date,
                    segment.arrival.hour) }}</div>
                </div>
              </div>

              <div class="flight-segment-identification"
                *ngIf="getAirlineInfo(segment) || getFullFlightNumber(segment)">
                <div class="flight-company" *ngIf="getAirlineInfo(segment)">
                  <i class="fas fa-plane-departure"></i>
                  {{ getAirlineInfo(segment) }}
                </div>
                <div class="flight-number" *ngIf="getFullFlightNumber(segment)">
                  <i class="fas fa-plane"></i>
                  {{ getFullFlightNumber(segment) }}
                </div>
              </div>
            </div>
          </ng-container>

          <div class="flight-baggage">
            <ng-container *ngIf="hasFlightBaggageInfo(flight); else noFlightBaggage">
              <i class="fas fa-suitcase"></i>
              <span [innerHTML]="getFlightBaggage(flight) | safeHtml"></span>
            </ng-container>
            <ng-template #noFlightBaggage>
              <i class="fas fa-suitcase text-muted"></i>
              <span class="text-muted">{{ 'ITINERARY.TRANSPORT.FLIGHT.NO_BAGGAGE' | translate }}</span>
            </ng-template>
          </div>

          <div class="flight-details-info">
            <div class="flight-class">
              <i class="fas fa-chair"></i>
              {{ getFlightClass(flight) }}
            </div>
            <div class="aircraft-type" *ngIf="hasAircraftType(flight)">
              <i class="fas fa-plane"></i>
              {{ getAircraftType(flight) }}
            </div>
            <div class="flight-pax" *ngIf="getFlightPax(flight) > 0">
              <i class="fas fa-users"></i>
              {{ getFlightPax(flight) }} {{ getFlightPax(flight) === 1 ? ('ITINERARY.TRANSPORT.FLIGHT.PASSENGER_SINGULAR' | translate) : ('ITINERARY.TRANSPORT.FLIGHT.PASSENGER_PLURAL' | translate) }}
            </div>
          </div>
          <div class="service-notes" *ngIf="getServiceNotesHtml(flight)"
            [innerHTML]="getServiceNotesHtml(flight) | safeHtml">
          </div>
        </div>
      </div>
    </div>

    <!-- Mappa itinerario -->
    <div class="print-map-section" *ngIf="shouldShowMap() && getMapSteps().length > 0 && !mapImageError">
      <div class="service-header">
        <div class="service-icon-wrapper map-icon">
          <app-print-icon icon="map" [customPath]="getIconPath('map')"></app-print-icon>
        </div>
        <h2 class="service-title">{{ 'HOME.MAP' | translate }}</h2>
      </div>
      <div class="print-map-container" [style.height]="getMapHeight()">
        <img [src]="getStaticMapUrl()" [alt]="'HOME.MAP' | translate" class="print-map-image" (error)="onMapImageError($event)">
        <svg class="print-map-overlay" [attr.viewBox]="getMapOverlayViewBox()" preserveAspectRatio="xMidYMid slice">
          <polyline
            class="print-map-line"
            [attr.points]="getMapSvgPathPoints()"
            fill="none"
            [attr.stroke]="getMapLineColor()"
            [attr.stroke-width]="getMapPathWeight()"
            [attr.stroke-linecap]="'round'"
            [attr.stroke-linejoin]="'round'">
          </polyline>
          <g
            *ngFor="let pos of getMapMarkerPositions(); let i = index"
            class="print-map-marker"
            [attr.transform]="'translate(' + pos.x + ',' + pos.y + ')'">
            <circle class="print-map-marker-bg" [attr.r]="getMapMarkerRadius()" [attr.fill]="getMapPinColor()"></circle>
            <text class="print-map-marker-label" x="0" [attr.y]="getMapMarkerFontSize() / 3" text-anchor="middle" [attr.fill]="getMapMarkerTextColor()" [attr.font-size]="getMapMarkerFontSize()" font-weight="bold">{{ i + 1 }}</text>
          </g>
        </svg>
      </div>
    </div>

    <ng-container *ngIf="locationDetailsPosition === 'header'">
      <ng-container *ngTemplateOutlet="locationDetailsSection"></ng-container>
    </ng-container>

    <!-- Tappe del Viaggio (senza voli) -->
    <div class="travel-journey-container">
      <ng-container *ngFor="let tappa of tappe; let tappaIndex = index">

        <!-- Tappa Header Card -->
        <div class="tappa-journey-card" [class.page-break-before]="tappaIndex > 0">
          <div class="tappa-number-badge">
            <span class="tappa-number">{{ tappaIndex + 1 }}</span>
            <span class="tappa-label">{{ 'COMMON.TAPPA' | translate }}</span>
          </div>

          <div class="tappa-content-wrapper">
            <div class="tappa-header-section">
              <h2 class="tappa-title">{{ tappa.city_title || tappa.city_name }}</h2>
              <div class="tappa-dates">
                <i class="fas fa-calendar-alt"></i>
                <span>{{ formatDateRange(tappa.start_date, tappa.end_date) }}</span>
              </div>
            </div>

            <!-- City Showcase Section - Aggiungi questa sezione -->
            <div class="service-section city-section" *ngIf="!locationDetailsPosition && hasCityInfo(tappa)">
              <div class="city-showcase">
                <div class="city-image-container" *ngIf="getCityPhoto(tappa)">
                  <img [src]="getCityPhoto(tappa)" [alt]="'Immagine di ' + (tappa.city_title || tappa.city_name)" class="city-image"
                    (error)="$event.target.src = noImageUrl">
                  <div class="image-overlay">
                    <div class="city-name-overlay"></div>
                  </div>
                </div>

                <div class="city-description" *ngIf="getCityDescription(tappa)">
                  <div class="city-description-content" [innerHTML]="getCityDescription(tappa) | safeHtml"></div>
                </div>
              </div>
            </div>

            <!-- Sezione Servizi per ogni tappa -->
            <div class="tappa-services">

              <!-- Servizi di terra interleaved cronologicamente (come nel portale) -->
              <ng-container *ngFor="let entry of tappa.serviceOrder">
                <ng-container [ngSwitch]="entry.type">

                  <!-- Hotels Section -->
                  <div class="service-section hotel-section" *ngSwitchCase="'hotel'">
                    <div class="service-header">
                      <div class="service-icon-wrapper hotel-icon">
                        <app-print-icon icon="hotel" [customPath]="getIconPath('hotel')"></app-print-icon>
                      </div>
                      <h3 class="service-title">{{ "HOME.SISTEMAZIONI" | translate }}</h3>
                    </div>
                    <div class="service-list">
                      <div class="service-item escorted-flex">
                        <div class="escorted-header">
                          <div class="service-name">
                            <strong>{{ getHotelName(entry.service) }}</strong>
                            <app-pnr [pnr]="entry.service.hotels[0]?.pnr" [supplierName]="entry.service.hotels[0]?.supplierName"></app-pnr>
                          </div>
                          <div class="service-dates">
                            <i class="fas fa-calendar"></i>
                            {{ getHotelDates(entry.service) }}
                          </div>
                        </div>
                        <div class="escorted-body-row">
                          <div class="escorted-step-image" *ngIf="getFirstImageUrl(entry.service?.hotels)">
                            <img [src]="getFirstImageUrl(entry.service?.hotels)" [alt]="getHotelName(entry.service)" class="step-photo" (error)="handleImgError($event)">
                          </div>
                          <div class="escorted-details">
                            <div class="service-address" *ngIf="entry.service.hotels && entry.service.hotels[0] && entry.service.hotels[0].address">
                              <i class="fas fa-map-marker-alt"></i>
                              {{ entry.service.hotels[0].address }}
                            </div>
                            <div class="service-notes" *ngIf="getServiceNotesHtml(entry.service)"
                              [innerHTML]="getServiceNotesHtml(entry.service) | safeHtml">
                            </div>
                            <div class="service-description" *ngIf="entry.service.hotels && entry.service.hotels[0] && entry.service.hotels[0].description"
                              [innerHTML]="entry.service.hotels[0].description | safeHtml">
                            </div>
                            <div class="service-rooms" *ngIf="entry.service.hotels && entry.service.hotels[0] && entry.service.hotels[0].rooms">
                              <ng-container *ngFor="let room of entry.service.hotels[0].rooms">
                                <i class="fas fa-bed"></i>
                                {{ room.room_description | lowercase }},
                                {{ room.plan_description | lowercase }}
                                <div>
                                  <span class="room-pax">
                                    <i class="fas fa-users"></i>
                                    {{ getRoomPax(room) }} {{ getRoomPax(room) === 1 ? ('COMMON.PERSON_SINGULAR' | translate) : ('COMMON.PERSON_PLURAL' | translate) }}
                                  </span><br>
                                  <span *ngIf="room.additional_info" class="text-primary"><small
                                    [innerHTML]="room.additional_info | safeHtml"></small></span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Vehicles Section -->
                  <div class="service-section vehicle-section" *ngSwitchCase="'car'">
                    <div class="service-header">
                      <div class="service-icon-wrapper vehicle-icon">
                        <app-print-icon icon="car" [customPath]="getIconPath('car')"></app-print-icon>
                      </div>
                      <h3 class="service-title">{{ "HOME.RENT-A-CAR" | translate }}</h3>
                    </div>
                    <div class="service-list">
                      <div class="service-item escorted-flex">
                        <div class="escorted-header">
                          <div class="service-name" *ngIf="entry.service.vehicles && entry.service.vehicles[0]">
                            <strong>{{ entry.service.vehicles[0].model }}</strong>
                            <app-pnr [pnr]="entry.service.vehicles[0]?.pnr" [supplierName]="entry.service.vehicles[0]?.supplierName"></app-pnr>
                          </div>
                          <div class="service-dates">
                            <i class="fas fa-calendar"></i>
                            {{ entry.service.pickup?.date | localizedDate:'dd/MM/yyyy' }} - {{ entry.service.dropoff?.date | localizedDate:'dd/MM/yyyy' }}
                          </div>
                        </div>
                        <div class="escorted-body-row">
                          <div class="escorted-step-image" *ngIf="getFirstImageUrl(entry.service?.vehicles)">
                            <img [src]="getFirstImageUrl(entry.service?.vehicles)" [alt]="entry.service.vehicles[0]?.model" class="step-photo" (error)="handleImgError($event)">
                          </div>
                          <div class="escorted-details">
                            <div class="service-car-class"
                              *ngIf="getVehicleClassDescription(entry.service.vehicles[0])">
                              <i class="fas fa-car-side"></i>
                              {{ getVehicleClassDescription(entry.service.vehicles[0]) }}
                            </div>
                            <div class="service-company" *ngIf="entry.service.vehicles && entry.service.vehicles[0] && entry.service.vehicles[0].vendor">
                              <i class="fas fa-store"></i>
                              {{ entry.service.vehicles[0].vendor.name }}
                            </div>
                            <div class="vehicle-features" *ngIf="entry.service.vehicles[0]?.services">
                              <span class="feature-item" *ngIf="entry.service.vehicles[0].services.doors">
                                <i class="fas fa-door-open"></i> {{ entry.service.vehicles[0].services.doors }}
                              </span>
                              <span class="feature-item" *ngIf="entry.service.vehicles[0].services.passengerQuantity">
                                <i class="fas fa-user"></i> {{ entry.service.vehicles[0].services.passengerQuantity }}
                              </span>
                              <span class="feature-item" *ngIf="entry.service.vehicles[0].services.baggageQuantityMax">
                                <i class="fas fa-suitcase"></i> {{ entry.service.vehicles[0].services.baggageQuantityMax }}
                              </span>
                              <span class="feature-item" *ngIf="entry.service.vehicles[0].services.transmission">
                                <i class="fas fa-cog"></i> {{ entry.service.vehicles[0].services.transmission }}
                              </span>
                              <span class="feature-item" *ngIf="entry.service.vehicles[0].services.airConditioned">
                                <i class="fas fa-snowflake"></i> A/C
                              </span>
                            </div>
                            <div class="vehicle-locations" *ngIf="entry.service.vehicles[0]?.locations">
                              <div class="location-item" *ngIf="entry.service.vehicles[0].locations.pickup?.length">
                                <i class="fas fa-map-marker-alt"></i>
                                <strong>Pickup:</strong> {{ entry.service.vehicles[0].locations.pickup[0].name }}
                                <span *ngIf="entry.service.vehicles[0].locations.pickup[0].address"> - {{ entry.service.vehicles[0].locations.pickup[0].address }}</span>
                              </div>
                              <div class="location-item" *ngIf="entry.service.vehicles[0].locations.dropoff?.length">
                                <i class="fas fa-map-marker-alt"></i>
                                <strong>Dropoff:</strong> {{ entry.service.vehicles[0].locations.dropoff[0].name }}
                                <span *ngIf="entry.service.vehicles[0].locations.dropoff[0].address"> - {{ entry.service.vehicles[0].locations.dropoff[0].address }}</span>
                              </div>
                            </div>
                            <div class="service-notes" *ngIf="getServiceNotesHtml(entry.service)"
                              [innerHTML]="getServiceNotesHtml(entry.service) | safeHtml">
                            </div>
                            <div class="service-description" *ngIf="getVehicleDescription(entry.service)"
                              [innerHTML]="getVehicleDescription(entry.service) | safeHtml">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Transfers Section -->
                  <div class="service-section transfer-section" *ngSwitchCase="'transfer'">
                    <div class="service-header">
                      <div class="service-icon-wrapper transfer-icon">
                        <app-print-icon icon="shuttle-van" [customPath]="getIconPath('shuttle-van')"></app-print-icon>
                      </div>
                      <h3 class="service-title">{{ "COMMON.TRANSFER" | translate }}</h3>
                    </div>
                    <div class="service-list">
                      <div class="service-item escorted-flex">
                        <div class="escorted-header">
                          <div class="service-name">
                            <strong>{{ getServiceName(entry.service) }}</strong>
                            <app-pnr [pnr]="entry.service.optionals[0]?.pnr" [supplierName]="entry.service.optionals[0]?.supplierName"></app-pnr>
                          </div>
                          <div class="service-dates">
                            <i class="fas fa-calendar"></i>
                            {{ entry.service.day_date | localizedDate:'dd/MM/yyyy' }}
                          </div>
                        </div>
                        <div class="escorted-body-row">
                          <div class="escorted-step-image" *ngIf="getFirstImageUrl(entry.service?.optionals)">
                            <img [src]="getFirstImageUrl(entry.service?.optionals)" [alt]="getServiceName(entry.service)" class="step-photo" (error)="handleImgError($event)">
                          </div>
                          <div class="escorted-details">
                            <div class="service-type" *ngIf="getServiceType(entry.service)">
                              <i class="fas fa-info-circle"></i>
                              {{ getServiceType(entry.service) }}
                            </div>
                            <div class="service-pax" *ngIf="getTotalServicePax(entry.service) > 0">
                              <i class="fas fa-users"></i>
                              {{ getTotalServicePax(entry.service) }} {{ getTotalServicePax(entry.service) === 1 ? ('COMMON.PERSON_SINGULAR' | translate) : ('COMMON.PERSON_PLURAL' | translate) }}
                            </div>
                            <div class="service-description" *ngIf="getServiceDescription(entry.service)"
                              [innerHTML]="getServiceDescription(entry.service) | safeHtml">
                            </div>
                            <div class="service-items" *ngIf="hasSupplementsAndReductions(entry.service)">
                              <div class="item-detail" *ngFor="let item of getSupplementsAndReductions(entry.service)">
                                <div class="item-name" *ngIf="item?.text && item.text.trim()">
                                  • {{ item.text }}
                                </div>
                              </div>
                            </div>
                            <div class="service-items" *ngIf="hasServiceItems(entry.service)">
                              <div class="item-detail" *ngFor="let item of getServiceItems(entry.service)">
                                <div class="item-name" *ngIf="item.name && item.name.trim()">
                                  • {{ item.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Optional Services Section -->
                  <div class="service-section optional-section" *ngSwitchCase="'optional'">
                    <div class="service-header">
                      <div class="service-icon-wrapper optional-icon">
                        <app-print-icon icon="star" [customPath]="getIconPath('star')"></app-print-icon>
                      </div>
                      <h3 class="service-title">{{ "COMMON.ESPERIENZE" | translate }}</h3>
                    </div>
                    <div class="service-list">
                      <div class="service-item escorted-flex">
                        <div class="escorted-header">
                          <div class="service-name">
                            <strong>{{ getServiceName(entry.service) }}</strong>
                            <app-pnr [pnr]="entry.service.optionals[0]?.pnr" [supplierName]="entry.service.optionals[0]?.supplierName"></app-pnr>
                          </div>
                          <div class="service-dates">
                            <i class="fas fa-calendar"></i>
                            {{ entry.service.day_date | localizedDate:'dd/MM/yyyy' }}
                          </div>
                        </div>
                        <div class="escorted-body-row">
                          <div class="escorted-step-image" *ngIf="getFirstImageUrl(entry.service?.optionals)">
                            <img [src]="getFirstImageUrl(entry.service?.optionals)" [alt]="getServiceName(entry.service)" class="step-photo" (error)="handleImgError($event)">
                          </div>
                          <div class="escorted-details">
                            <div class="service-type" *ngIf="getServiceType(entry.service)">
                              <i class="fas fa-info-circle"></i>
                              {{ getServiceType(entry.service) }}
                            </div>
                            <div class="service-city" *ngIf="getServiceCity(entry.service)">
                              <i class="fas fa-map-marker-alt"></i>
                              {{ getServiceCity(entry.service) }}
                            </div>
                            <div class="service-pax" *ngIf="getTotalServicePax(entry.service) > 0">
                              <i class="fas fa-users"></i>
                              {{ getTotalServicePax(entry.service) }} {{ getTotalServicePax(entry.service) === 1 ? ('COMMON.PERSON_SINGULAR' | translate) : ('COMMON.PERSON_PLURAL' | translate) }}
                            </div>
                            <div class="service-description" *ngIf="getServiceDescription(entry.service)"
                              [innerHTML]="getServiceDescription(entry.service) | safeHtml">
                            </div>
                            <div class="service-items" *ngIf="hasSupplementsAndReductions(entry.service)">
                              <div class="item-detail" *ngFor="let item of getSupplementsAndReductions(entry.service)">
                                <div class="item-name" *ngIf="item?.text && item.text.trim()">
                                  • {{ item.text }}
                                </div>
                              </div>
                            </div>
                            <div class="service-items" *ngIf="hasServiceItems(entry.service)">
                              <div class="item-detail" *ngFor="let item of getServiceItems(entry.service)">
                                <div class="item-name" *ngIf="item.name && item.name.trim()">
                                  • {{ item.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="service-section escorted-section" *ngSwitchCase="'escorted'">
                    <div class="service-header">
                      <div class="service-icon-wrapper escorted-icon">
                        <app-print-icon icon="user-tie" [customPath]="getIconPath('user-tie')"></app-print-icon>
                      </div>
                      <h3 class="service-title">{{ "HOME.ESCORTEDS" | translate }}</h3>
                    </div>
                    <div class="service-list">
                      <div class="service-item escorted-flex">
                        <ng-container *ngIf="entry.service._showHeader">
                          <div class="escorted-header">
                            <div class="service-name">
                              <strong>{{ entry.service.optionals[0]?.type }}</strong>
                              <app-pnr [pnr]="entry.service.optionals[0]?.pnr" [supplierName]="getSupplierName(entry.service.optionals[0])"></app-pnr>
                            </div>
                          </div>
                          <div class="service-room" *ngIf="entry.service.optionals && entry.service.optionals[0] && entry.service.optionals[0].items && entry.service.optionals[0].items[0] && entry.service.optionals[0].items[0].name">
                            <i class="fas fa-bed"></i>
                            {{ entry.service.optionals[0].items[0].name }}
                          </div>
                          <div class="service-pax" *ngIf="(getTotalServicePax(entry.service) || getBookingTotalPax()) > 0">
                            <i class="fas fa-users"></i>
                            {{ getTotalServicePax(entry.service) || getBookingTotalPax() }} {{ (getTotalServicePax(entry.service) || getBookingTotalPax()) === 1 ? ('COMMON.PERSON_SINGULAR' | translate) : ('COMMON.PERSON_PLURAL' | translate) }}
                          </div>
                          <div class="escorted-body-row" *ngIf="entry.service.optionals && entry.service.optionals[0]">
                            <div class="escorted-step-image" *ngIf="getFirstImageUrl(entry.service?.optionals)">
                              <img [src]="getFirstImageUrl(entry.service?.optionals)" [alt]="entry.service.optionals[0]?.type" class="step-photo" (error)="handleImgError($event)">
                            </div>
                            <div class="escorted-details">
                              <div class="service-description" *ngIf="entry.service.optionals[0]?.description"
                                [innerHTML]="entry.service.optionals[0].description | safeHtml">
                              </div>
                              <div class="escorted-included" *ngIf="getServiziInclusiDescription(entry.service)">
                                <div class="service-type included-title">
                                  <strong>{{ "ITINERARY.VEHICLE.INCLUDED_IN_BASE_PRICE" | translate }}</strong>
                                </div>
                                <div class="service-description"
                                  [innerHTML]="getServiziInclusiDescription(entry.service) | safeHtml">
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <div class="escorted-header">
                          <div class="service-dates">
                            <i class="fas fa-calendar"></i>
                            {{ getEscortedStepDateRange(entry.service) }}
                          </div>
                        </div>
                        <div class="escorted-body-row">
                          <div class="escorted-step-image" *ngIf="hasEscortedStepPhoto(entry.service)">
                            <img [src]="getEscortedStepPhoto(entry.service)" [alt]="entry.service.step?.cityName" class="step-photo"
                              (error)="handleImgError($event)">
                          </div>
                          <div class="escorted-details">
                            <div class="service-type" *ngIf="entry.service.step?.cityName">
                              <i class="fas fa-map-marker-alt"></i>
                              {{ entry.service.step.cityName }}
                            </div>
                            <div class="service-description" *ngIf="getServiceDescription(entry.service)"
                              [innerHTML]="getServiceDescription(entry.service) | safeHtml">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>
              </ng-container>

            </div>
          </div>
        </div>

      </ng-container>
    </div>

    <!-- Sezione Totale Viaggio - Dopo le tappe -->
    <div class="travel-total-section" *ngIf="!iter?.hidePriceInB2C">
      <div class="service-header">
        <div class="service-icon-wrapper total-icon">
          <app-print-icon icon="calculator" [customPath]="getIconPath('calculator')"></app-print-icon>
        </div>
        <h2 class="service-title">{{ "COMMON.SUMMARY" | translate }}</h2>
      </div>

      <div class="total-breakdown-container">
        <div class="total-breakdown-card">
          <!-- <div class="breakdown-content">
            <div class="cost-line">
              <div class="cost-label">
                <i class="fas fa-plane"></i>
                <span>{{ "COMMON.SERVICE_FLIGHT" | translate }}</span>
              </div>
              <div class="cost-amount">
                {{ totalFlightsService | currency:'EUR':'symbol':'1.2-2' }}
              </div>
            </div>

            <div class="cost-line">
              <div class="cost-label">
                <i class="fas fa-globe"></i>
                <span>{{ "COMMON.SERVICE_LAND" | translate }}</span>
              </div>
              <div class="cost-amount">
                {{ totalGroundService | currency:'EUR':'symbol':'1.2-2' }}
              </div>
            </div>

            <div class="cost-line" *ngIf="getAdvInformations().feeFlight > 0">
              <div class="cost-label">
                <i class="fas fa-percentage"></i>
                <span>{{ "COMMON.COMMISSIONS_FLIGHT" | translate }}</span>
              </div>
              <div class="cost-amount">
                {{ getAdvInformations().feeFlight | currency:'EUR':'symbol':'1.2-2' }}
              </div>
            </div>

            <div class="cost-line" *ngIf="getAdvInformations().feeLandServices > 0">
              <div class="cost-label">
                <i class="fas fa-percentage"></i>
                <span>{{ "COMMON.COMMISSIONS_SERVICE" | translate }}</span>
              </div>
              <div class="cost-amount">
                {{ getAdvInformations().feeLandServices | currency:'EUR':'symbol':'1.2-2' }}
              </div>
            </div>

            <div class="cost-line" *ngIf="totalFeeInsuranceService > 0">
              <div class="cost-label">
                <i class="fas fa-shield-alt"></i>
                <span>{{ "COMMON.INSURANCE" | translate }}</span>
              </div>
              <div class="cost-amount">
                {{ totalFeeInsuranceService | currency:'EUR':'symbol':'1.2-2' }}
              </div>
            </div>
          </div> -->

          <div class="breakdown-total">
            <div class="total-line">
              <div class="total-label">
                <i class="fas fa-receipt"></i>
                <span>{{ "COMMON.TOTAL" | translate }}</span>
              </div>
              <div class="total-amount">
                {{ (amountApis?.totalPrice || 0) + (advInformations?.feeFlight || 0) +
                (advInformations?.feeFlightTaxes || 0) + (advInformations?.feeLandServices || 0) |
                localizedCurrency:"EUR":'symbol' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="locationDetailsPosition === 'footer'">
      <ng-container *ngTemplateOutlet="locationDetailsSection"></ng-container>
    </ng-container>

    <ng-template #locationDetailsSection>
      <div class="travel-locations-section" *ngIf="locationDetails.length > 0">
        <div class="service-header">
          <div class="service-icon-wrapper city-icon">
            <app-print-icon icon="map-marker-alt" [customPath]="getIconPath('map-marker-alt')"></app-print-icon>
          </div>
          <h2 class="service-title">{{ 'HOME.TRAVEL_STEPS' | translate }}</h2>
        </div>
        <div class="travel-location-item" *ngFor="let location of locationDetails">
          <h3 class="travel-location-title">{{ location.name }}</h3>
          <div class="city-showcase">
            <div class="city-image-container" *ngIf="location.photo">
              <img [src]="location.photo" [alt]="location.name" class="city-image" (error)="handleImgError($event)">
            </div>
            <div class="city-description" *ngIf="location.description">
              <div class="city-description-content" [innerHTML]="location.description | safeHtml"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="travel-notes-section" *ngIf="hasNotesToShow()">
      <div class="service-header">
        <div class="service-icon-wrapper notes-icon">
          <app-print-icon icon="sticky-note" [customPath]="getIconPath('sticky-note')"></app-print-icon>
        </div>
        <h2 class="service-title">{{ "HOME.NOTES" | translate }}</h2>
      </div>

      <!-- Note Generali -->
      <div class="notes-category" *ngIf="getFilteredGeneralNotes().length > 0">
        <div class="note-item general-note">
          <ng-container *ngFor="let generalNote of getFilteredGeneralNotes()">
            <ng-container *ngIf="generalNote.type === 'NEWSHEET'">
              <div class="note-header">
                <!-- <div class="note-type-icon">
                      <i class="fas fa-info-circle"></i>
                    </div>    -->
                <h4 *ngIf="generalNote.position === 'HEADER'" class="note-title">{{ "NOTE.HEADERTITLE" | translate }}
                </h4>
                <h4 *ngIf="generalNote.position === 'FOOTER'" class="note-title">{{ "NOTE.FOOTERTITLE" | translate }}
                </h4>
              </div>
              <div class="note-content" [innerHTML]="generalNote.text | safeHtml"></div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- Note per Paese -->
      <div class="notes-category" *ngIf="getFilteredCountryNotes().length > 0">
        <ng-container *ngFor="let countryNote of getFilteredCountryNotes()">
          <div class="note-item country-note">
            <div class="note-header">
              <!-- <div class="note-type-icon">
                <i class="fas fa-globe"></i>
              </div> -->
              <h4 class="note-title">{{ "COMMON.INFORMATION" | translate }} - {{ countryNote.countryName }}</h4>
            </div>
            <div class="note-content" [innerHTML]="countryNote.text | safeHtml"></div>
          </div>
        </ng-container>
      </div>

      <!-- Note Fornitori -->
      <div class="notes-category" *ngIf="getFilteredSupplierNotes().length > 0">
        <ng-container *ngFor="let supplierNote of getFilteredSupplierNotes()">
          <div class="note-item supplier-note">
            <div class="note-header">
              <!-- <div class="note-type-icon">
                <i class="fas fa-building"></i>
              </div> -->
              <h4 class="note-title">{{ supplierNote.supplierName }}</h4>
              <div class="note-subtitle" *ngIf="supplierNote.countryName">
                <i class="fas fa-map-marker-alt"></i>
                {{ supplierNote.countryName }}
              </div>
            </div>
            <div class="note-content" [innerHTML]="supplierNote.text | safeHtml"></div>
          </div>
        </ng-container>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer">
  <button *ngIf="isModal" type="button" class="btn btn-info" (click)="sendEmail()">
    <i class="fas fa-envelope"></i> {{ 'EMAIL_MODAL.SEND_BUTTON' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="print()">
    <i class="fas fa-print"></i> {{ 'COMMON.PRINT' | translate }}
  </button>
</div>
